var _style, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAiLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "220px",
    height: "220px",
    viewBox: "0 0 220 220",
    style: {
      enableBackground: "new 0 0 220 220"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2B150A;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#FF841B;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200,220H20c-11,0-20-9-20-20V20C0,9,9,0,20,0h180c11,0,20,9,20,20v180C220,211.1,211.1,220,200,220z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.5,168.4h68c0.7,0,1.2,0.6,1.2,1.2v19.2c0,0.7-0.6,1.2-1.2,1.2H51.5c-0.9,0-1.5-1-1.1-1.8L131,30.8 c0.2-0.4,0.6-0.7,1.1-0.7h22.5c0.9,0,1.5,1,1.1,1.8L86.4,166.6C85.9,167.4,86.5,168.4,87.5,168.4z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.2,50.5c1,0.4,1.4,1.6,0.9,2.5c0,0,0,0,0,0.1c-0.3,0.5-0.5,0.9-0.9,1.3c-1.1,1.1-2.3,2.1-3.5,3.1 c-1.2,1-2.4,2-3.6,2.9c-0.9,0.7-1.7,1.5-2.5,2.4c-1.4,1.7-2.4,3.6-3,5.7c-0.3,1.1-0.5,2.2-0.5,3.3c-0.1,1.4,0,2.8,0,4.2 c0,1.5,0,3.1-0.1,4.6c0,0.7,0,1.4-0.2,2c-0.1,0.5-0.4,1.1-0.8,1.5c-0.3,0.4-0.7,0.6-1.1,0.6c-0.5,0-1.1-0.3-1.5-0.6 c-0.5-0.3-1-0.8-1.4-1.3c-0.5-0.6-1-1.1-1.5-1.7c-1-1.2-2-2.4-3-3.6c-0.9-1-1.7-2.1-2.7-3c-1.6-1.5-3.6-2.7-5.8-3.4 c-1.1-0.3-2.2-0.5-3.4-0.6c-1.4-0.1-2.9-0.1-4.4-0.1c-1.6,0-3.1,0-4.7-0.1c-1.3-0.1-2.6,0-3.7-0.7c-0.4-0.2-0.7-0.5-0.7-1 c0-0.6,0.1-1.2,0.4-1.7c0.3-0.6,0.7-1,1.1-1.4c0.6-0.5,1.1-1,1.7-1.5c1.2-1,2.4-2,3.6-2.9c1-0.8,2-1.6,2.9-2.5 c1.5-1.6,2.7-3.4,3.5-5.5c0.4-1,0.6-2.1,0.8-3.2c0.2-1.2,0.2-2.5,0.2-3.7c0-1.5,0-3.1,0-4.6c0-0.8,0.1-1.5,0.1-2.3 c0-0.6,0.1-1.2,0.3-1.8c0.2-0.5,0.4-1.1,0.8-1.5c0.3-0.3,0.7-0.4,1.1-0.4c0.5,0.1,1.1,0.3,1.5,0.6c0.5,0.3,0.9,0.8,1.4,1.2 c1,1.1,2,2.3,3,3.5c0.9,1.1,1.8,2.3,2.8,3.4c1.5,1.7,3.3,3.1,5.4,4c2.1,1,4.4,1.3,6.8,1.3c1.6,0,3.1,0,4.7,0.1c0.8,0,1.6,0,2.3,0.1 c0.7,0,1.5,0,2.2,0.1C87.2,50.1,87.7,50.3,88.2,50.5C88.2,50.5,88.2,50.5,88.2,50.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAiLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ai-logo.ea1f00578be8631d0b763eeffd3968cc.svg";